import { render, staticRenderFns } from "./Decoder.vue?vue&type=template&id=12f5a4ba&scoped=true&lang=pug&"
import script from "./Decoder.vue?vue&type=script&lang=js&"
export * from "./Decoder.vue?vue&type=script&lang=js&"
import style0 from "./Decoder.vue?vue&type=style&index=0&id=12f5a4ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f5a4ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12f5a4ba')) {
      api.createRecord('12f5a4ba', component.options)
    } else {
      api.reload('12f5a4ba', component.options)
    }
    module.hot.accept("./Decoder.vue?vue&type=template&id=12f5a4ba&scoped=true&lang=pug&", function () {
      api.rerender('12f5a4ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/older_adult/Decoder.vue"
export default component.exports